import CustomState from '@rio-cloud/rio-uikit/CustomState';
import { FormattedMessage } from 'react-intl';

export default function DriverState({ headlineId, messageId }: { headlineId: string; messageId: string }) {
    return (
        <div data-test="DriverState">
            <CustomState
                headline={<FormattedMessage id={headlineId} />}
                message={<FormattedMessage id={messageId} />}
                icons={[
                    {
                        name: 'rioglyph-driver',
                        className: 'text-size-200pct',
                    },
                    {
                        name: 'rioglyph-driver',
                        className: 'text-size-300pct',
                    },
                    {
                        name: 'rioglyph-driver',
                        className: 'text-size-200pct',
                    },
                ]}
            />
        </div>
    );
}
